export enum SubMenu {
  AppsAndCollections = 'menuAppsAndCollections',
  Configuration = 'menuConfig',
  Software = 'menuSoftware',
  Develop = 'menuDevelop',
}
